<div class="card-button" [hidden]="actionButtons.length == 0" *ngFor="let item of actionButtons">
    {{ item.textBeforeBtn }}
    <button class="btn f-11 position-relative top--3px" [hidden]="item.buttonText==''"
        (click)="onUserAction(item.userAction);" [class]="item.buttonClass" [ngClass]="{'disabled-state': item.disableProperty }" >
        {{ item.buttonText }}
    </button>
</div>